import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
//
import { isFeatureActive } from '../../redux/reducers/config/configReducer';
import featureConstants from '../../constants/featureConstants';
import ESIInclude from '../esi-include/ESIInclude';

export const Recommendations = props => <ESIInclude {...props} />;

Recommendations.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string,
};

Recommendations.defaultProps = {
  id: '',
  src: undefined,
};

export function mapStateToProps(state) {

  const serverSideFetch = isFeatureActive(state, featureConstants.RECOMMENDATIONS_SERVERSIDE_FETCH);

  const items = get(state, 'orderForm.items', []);
  const productIds = items.map(item => item.productId);
  const skuIds = items.map(item => item.skuId);

  const placement = 'OSPOrderConfirmation1';
  const params = new URLSearchParams({
    placement,
    productId: productIds.join(),
    skuId: skuIds.join(),
    ...serverSideFetch && { serverSideFetch },
  }).toString();

  const id = `jl-recommendations-panel-esi-${placement.toLowerCase()}`;
  const src = `${window.publicJLSiteDomain}/esi/recommendations/?${params}`;

  return { id, src };
}

export default connect(state => mapStateToProps(state))(Recommendations);
